/**
 * Zod refinement that accepts either a valid URL, a relative path, or a
 * string containing `{{token}}` template placeholders.
 *
 * Used in step schemas to allow authors to write `{{character_image}}`
 * in URL fields — these are resolved at runtime via `deepInterpolate`.
 */
import { z } from "zod";

const TEMPLATE_TOKEN_RE = /\{\{\w+\}\}/;
const RELATIVE_PATH_RE = /^\/(?!\/)[^\s]+$/;

export const urlOrTemplate = z.string().refine(
  (val) => {
    if (TEMPLATE_TOKEN_RE.test(val)) return true;
    if (RELATIVE_PATH_RE.test(val)) return true;
    try {
      new URL(val);
      return true;
    } catch {
      return false;
    }
  },
  { message: "Invalid url (absolute URL, relative path, or {{token}} template expected)" },
);
